import { UpdateProjectTeamMemberAction } from 'src/actions/project/team-member/update/UpdateProjectTeamMember.actions';
import * as UpdateProjectTeamMemberTypes from 'src/actions/project/team-member/update/Types';

export interface UpdateProjectTeamMemberState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateProjectTeamMemberState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateProjectTeamMemberReducer(state: UpdateProjectTeamMemberState = initialState,
                                               action: UpdateProjectTeamMemberAction): UpdateProjectTeamMemberState {
  switch (action.type) {
    case UpdateProjectTeamMemberTypes.UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateProjectTeamMemberTypes.UPDATE_PROJECT_TEAM_MEMBER_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateProjectTeamMemberTypes.UPDATE_PROJECT_TEAM_MEMBER_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/team-members/UpdateProjectTeamMemberReducer.tsx